import React from "react";
import { withStyles } from "@material-ui/core/styles";
import NotesStyle from "../styles/notesStyle";
import { removeXSSAttacks } from "../common/helper";

const stickyTop = 35;

const NoteType = {
    medicalOrder: "medicalOrderNote",
    medicalPatient: "medicalPatientNote",
    order: "orderNote",
    patient: "patientNote"
};

const noteIdsMap = new Map([
    [NoteType.medicalOrder, {
        empty: "emptyMedicalOrderNote",
        missingText: "No medical order notes",
        dateColumn: "medicalOrderNoteDateColumn",
        noteColumn: "medicalOrderNoteColumn"
    }],
    [NoteType.medicalPatient, {
        empty: "emptyMedicalPatientNote",
        missingText: "No medical patient notes",
        dateColumn: "medicalPatientNoteDateColumn",
        noteColumn: "medicalPatientNoteColumn"
    }],
    [NoteType.order, {
        empty: "emptyOrderNote",
        missingText: "No notes for this order",
        dateColumn: "orderNoteDateColumn",
        noteColumn: "orderNoteColumn"
    }],
    [NoteType.patient, {
        empty: "emptyPatientNote",
        missingText: "No notes for this patient",
        dateColumn: "patientNoteDateColumn",
        noteColumn: "patientNoteColumn"
    }],
]);

const NotesSection = ({
    index = 0,
    ids = {
        dateColumn: '',
        noteColumn: ''
    },
    classes = {
        wrapper: '',
        dateColumn: '',
        noteColumn: '',
        notes: ''
    },
    labels = {
        dateColumn: '',
        noteColumn: ''
    },
    notes
}) => (
    <>
        <div className={classes.wrapper} style={{ top: `${index * stickyTop}px` }}>
            <div id={ids.dateColumn} className={classes.dateColumn}>
                {labels.dateColumn}
            </div>
            <div id={ids.noteColumn} className={classes.noteColumn}>
                {labels.noteColumn}
            </div>
        </div>
        <div className={classes.notes}>
            {notes}
        </div>
    </>
);

class Notes extends React.Component {
    componentDidMount() {
        const { GetOrderNotes = () => {}, productInfo, GetPatientNotes = () => {}, selectedCardData = {}, historyView, GetMedicalOrderNotes = () => {}, GetMedicalPatientNotes = () => {} } = this.props;
        GetMedicalOrderNotes(productInfo);
        !historyView && GetMedicalPatientNotes(productInfo);
        GetOrderNotes(productInfo);
        !historyView && GetPatientNotes(selectedCardData);
    }
    UNSAFE_componentWillUnmount() {
        const { ResetNotesTab = () => {} } = this.props;
        ResetNotesTab();
    }
    componentDidUpdate(prevProps) {
        const { ResetNotesTab = () => {}, GetMedicalOrderNotes = () => {}, GetMedicalPatientNotes = () => {}, GetOrderNotes = () => {}, GetPatientNotes = () => {}, historyView, selectedCardData = {}, isNoteAdded, productInfo = {}, isEmailSentToPatient } = this.props;
        if ((!prevProps.isNoteAdded && isNoteAdded) || (!prevProps.isEmailSentToPatient && isEmailSentToPatient)) {
            ResetNotesTab();
            GetMedicalOrderNotes(productInfo);
            !historyView && GetMedicalPatientNotes(productInfo);
            GetOrderNotes(productInfo);
            !historyView && GetPatientNotes(selectedCardData);
        }
    }
    getNotes = (data = [], type = "") => {
        const { classes } = this.props;
        const noteId = noteIdsMap.get(type);

        if (!data.length) {
            return (
                <div id={noteId.empty} className={classes.emptyRow}>
                    {noteId.missingText}
                </div>
            )
        }

        return (
            data.map((value, index) => {
                let style = value.Colorcode ? { backgroundColor: value.Colorcode } : {};
                let time = value.EntryDate ? `${value.EntryDate}` : null;
                return (
                    <div className={`${index % 2 === 0 ? classes.NotesOddRowWrapper : classes.NotesRowWrapper}`} style={style}>
                        <div id={noteId.dateColumn} className={classes.dateRowStyle}>{time}</div>
                        <div id={noteId.noteColumn} className={classes.noteRowStyle} ><div dangerouslySetInnerHTML={{ __html: removeXSSAttacks(value.Text) }} /></div>
                    </div>
                )
            })
        );
    }

    renderTemplateV2 = () => {
        const {
            classes,
            orderNotes: { OrderNotes = [] } = {},
            patientNotes: { PatientNotes = [] } = {},
            medicalOrderNotes: { OrderNotes: MedicalOrderNotes = [] } = {},
            medicalPatientNotes: { OrderNotes: MedicalPatientNotes = [] } = {},
            loading,
            historyView,
        } = this.props;

        const notes = [
            {
                key: 1,
                ids: {
                    dateColumn: 'medicalOrderNoteDate',
                    noteColumn: 'medicalOrderNote'
                },
                classes: {
                    wrapper: `${classes.tableHeader} ${classes.stickyHeader}`,
                    dateColumn: classes.dateSection,
                    noteColumn: classes.notesSection,
                    notes: 'medicalOrderNotes'
                },
                labels: {
                    dateColumn: 'Date',
                    noteColumn: 'Medical Order Notes'
                },
                notes: !loading && this.getNotes(MedicalOrderNotes || [], NoteType.medicalOrder),
                visible: true
            },
            {
                key: 2,
                ids: {
                    dateColumn: 'medicalPatientNoteDate',
                    noteColumn: 'medicalPatientNote'
                },
                classes: {
                    wrapper: `${classes.tableHeader} ${classes.stickyHeader}`,
                    dateColumn: classes.dateSection,
                    noteColumn: classes.notesSection,
                    notes: 'medicalPatientNotes'
                },
                labels: {
                    dateColumn: 'Date',
                    noteColumn: 'Medical Patient Notes'
                },
                notes: !loading && this.getNotes(MedicalPatientNotes || [], NoteType.medicalPatient),
                visible: !historyView
            },
            {
                key: 3,
                ids: {
                    dateColumn: 'orderNoteDate',
                    noteColumn: 'orderNote'
                },
                classes: {
                    wrapper: `${classes.tableHeader} ${classes.stickyHeader}`,
                    dateColumn: classes.dateSection,
                    noteColumn: classes.notesSection,
                    notes: 'orderNotes'
                },
                labels: {
                    dateColumn: 'Date',
                    noteColumn: 'Order Notes'
                },
                notes: !loading && this.getNotes(OrderNotes || [], NoteType.order),
                visible: true
            },
            {
                key: 4,
                ids: {
                    dateColumn: 'patientNoteDate',
                    noteColumn: 'patientNote'
                },
                classes: {
                    wrapper: `${classes.tableHeader} ${classes.stickyHeader}`,
                    dateColumn: classes.dateSection,
                    noteColumn: classes.notesSection,
                    notes: 'patientNotes'
                },
                labels: {
                    dateColumn: 'Date',
                    noteColumn: 'Patient Notes'
                },
                notes: !loading && this.getNotes(PatientNotes || [], NoteType.patient),
                visible: !historyView
            }
        ];

        return (
            <div data-app="notes-component-wrapper" className={classes.notesWrapper}>
                {
                    notes.filter(({ visible }) => visible).map(({ key, ...props }, index) => (
                        <NotesSection key={key} index={index} {...props} />
                    ))
                }
            </div>
        );
    }

    render() {
        return this.renderTemplateV2();
    }
}


export default withStyles(NotesStyle)(Notes);

